import {Navigate} from 'react-router-dom';
import {useRoles} from '../hooks/useRoles';

const RoleGuard = ({children, roles = []}) => {
    const {hasAnyRole} = useRoles();

    if (roles.length > 0 && !hasAnyRole(roles)) {
        return <Navigate to="/tableau-de-bord" replace/>;
    }

    return children;
};

export default RoleGuard;